import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default function DisabledFieldWrapper({ disabled, reason, children }) {
  if (!disabled) return children;

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{reason}</Tooltip>}>
      <div style={{ cursor: 'not-allowed' }}>{children}</div>
    </OverlayTrigger>
  );
}
